'use strict';

import * as dom from './lib/dom.js';

let loaded = false;

const toggleSubmenuItem = () => {
    
    const subMenuItems = document.querySelectorAll('.c-main-menu__item.menu-item-has-children');
    
    dom.forEachEl(subMenuItems, (item) => {
        item.addEventListener('click', (e)=>{
            if (dom.hasClass(e.target, 'menu-item') && e.target.tagName == 'A') {
                return;
            }
            console.log(e);
            e.preventDefault();

            if (dom.hasClass(item, 'active')) {
                dom.removeClass(item, 'active');
            } else {
                const currentActive = document.querySelector('.c-main-menu__item.menu-item-has-children.active');
                if (currentActive) {
                    dom.removeClass(currentActive,'active');
                }
    
                dom.addClass(item, 'active');
            }

            
        });
    })
    
};

const openMegaMenu = () => {
    const openMenuTriggers = document.querySelectorAll('.js-open-mega-menu');
    dom.forEachEl(openMenuTriggers, (trigger) => {
        trigger.addEventListener('click', (e)=>{
            e.preventDefault();

            const megaMenu = document.querySelector('.o-mega-menu');
        
            dom.addClass(megaMenu, 'active');
        });
    });
};

const closeMegaMenu = () => {
    const closeMenuTrigger = document.querySelector('.js-close-mega-menu');
    closeMenuTrigger.addEventListener('click', (e)=>{
        console.log('closeMegaMenu');
        e.preventDefault();

        const megaMenu = document.querySelector('.o-mega-menu.active');
    
        dom.removeClass(megaMenu, 'active');
    })
};

const toggleSearch = () => {
    const toggleTrigger = document.querySelectorAll('.js-search-triger');
    const mainHeader =  document.querySelector('.o-main-header');
    const searchBox =  document.querySelector('.c-search-content');
    dom.forEachEl(toggleTrigger, (trigger) => {
        trigger.addEventListener('click', (e)=>{
            e.preventDefault();
            console.log('toggleSearch');

            if (dom.hasClass(toggleTrigger[1], 'active')) {
                dom.removeClass(toggleTrigger[1], 'active');
                dom.removeClass(mainHeader, 'search-active');
                dom.removeClass(searchBox, 'active');
            } else {
                dom.addClass(toggleTrigger[1], 'active');
                dom.addClass(searchBox, 'active');
                dom.addClass(mainHeader, 'search-active');

                setTimeout(function(){
                    const searchInput = document.getElementById('global-search-input');
                    searchInput.focus();
                }, 600);
            }
        });
    });
};

export default function() {
	window.addEventListener('load', function() {
        if (loaded) { return; }
        loaded = true;
        const windowWidth = window.innerWidth;
        if(windowWidth < 1023){ toggleSubmenuItem(); }
        openMegaMenu();
        closeMegaMenu();
        toggleSearch();
	});

    window.addEventListener('turbolinks:load', function() {
        if (loaded) { return; }
        loaded = true;
        const windowWidth = window.innerWidth;
        if(windowWidth < 1023){ toggleSubmenuItem(); }
        openMegaMenu();
        closeMegaMenu();
        toggleSearch();
    });
};
